// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://cdn.jsdelivr.net/npm/bulma@0.9.4/css/bulma.min.css);"]);
// Module
exports.push([module.id, "crossmint-pay-button[data-v-44d9a181]{display:inline-block}.crossmint-wrapper[data-v-44d9a181],crossmint-pay-button[data-v-44d9a181]{width:-webkit-max-content;width:-moz-max-content;width:max-content}.crossmint-wrapper[data-v-44d9a181]{margin:auto;block-size:-webkit-max-content;block-size:-moz-max-content;block-size:max-content}button>p[data-v-44d9a181]{font-size:33px}.crossmintQtySelector[data-v-44d9a181]{z-index:0}", ""]);
// Exports
module.exports = exports;
